module.exports = __webpack_public_path__ + "static/media/banner-register.977b6b2f.png";